import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-lg-6"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12 col-lg-6 mb-25"
}
const _hoisted_5 = { class: "col-xxl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_PatientAnagraph = _resolveComponent("PatientAnagraph")!
  const _component_TherapyView = _resolveComponent("TherapyView")!
  const _component_SurveyCardsList = _resolveComponent("SurveyCardsList")!
  const _component_EventsCalendar = _resolveComponent("EventsCalendar")!
  const _component_MessagesBody = _resolveComponent("MessagesBody")!
  const _component_ContentPatientPermission = _resolveComponent("ContentPatientPermission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, { page: _ctx.patient_fullname }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.patients'),
          to: "/patients"
        }, null, 8 /* PROPS */, ["page"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_PatientAnagraph),
        _createVNode(_component_TherapyView),
        _createVNode(_component_SurveyCardsList)
      ]),
      (_ctx.config.feature.events)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_EventsCalendar, {
              patient_summary: _ctx.patient_summary,
              class: "h-100"
            }, null, 8 /* PROPS */, ["patient_summary"])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.config.feature.messages)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_MessagesBody, { show_patient_name: false })
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.update_enabled)
          ? (_openBlock(), _createBlock(_component_ContentPatientPermission, { key: 0 }))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}